import { ShelterService } from "../../../service/shelter.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import * as FeatureFlagAdopterHubActions from "./feature-flag-adopter-hub.actions";
import { FeatureFlagModel } from "../../../models/feature-flags-model";
import { of } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable()
export class FeatureFlagAdopterHubEffects {
  constructor(private actions$: Actions,
              private shelterService: ShelterService) {
  }

  loadFeatureFlagAdopterHub$ = createEffect(() => this.actions$.pipe(
    ofType(FeatureFlagAdopterHubActions.loadFeatureFlagAdopterHub),
    switchMap(() => this.shelterService.getFeatureFlagAdopterHub().pipe(
      map((featureFlagAdopterHub: FeatureFlagModel)=> FeatureFlagAdopterHubActions.setFeatureFlagAdopterHub({ featureFlagAdopterHub })),
      catchError(() => of(FeatureFlagAdopterHubActions.setFeatureFlagAdopterHub({ featureFlagAdopterHub: null })))
    ))
  ));
}
